/*globals com*/
import TransmitConstants from "./constants";
import * as log from "./utils/log";
import CustomTransportProvider from "./components/CustomTransportProvider";
const controller = new AbortController();
const getEnv = (host, server, isLoggingEnabled, secureaccess, internal) => {
  const isInternal = !server && !secureaccess && !!internal;
  if (host === "development" && window.location.hostname === "localhost") {
    return TransmitConstants.endpoints.default;
  }
  switch (host) {
    case "development":
      {
        const secureUrl = secureaccess ? TransmitConstants.endpoints.development : TransmitConstants.endpoints.securelink_dev;
        const serverUrl = server ? secureUrl : TransmitConstants.endpoints.devapigee;
        return isInternal ? TransmitConstants.endpoints.default : serverUrl;
      }
    case "qa":
      {
        const secureUrl = secureaccess ? TransmitConstants.endpoints.qa : TransmitConstants.endpoints.securelink_qa;
        const serverUrl = server ? secureUrl : TransmitConstants.endpoints.qaapigee;
        return isInternal ? TransmitConstants.endpoints.qa_proxy : serverUrl;
      }
    case "staging":
      {
        const secureUrl = secureaccess ? TransmitConstants.endpoints.stg : TransmitConstants.endpoints.securelink_stg;
        const serverUrl = server ? secureUrl : TransmitConstants.endpoints.stgapigee;
        return isInternal ? TransmitConstants.endpoints.stg_proxy : serverUrl;
      }
    default:
      {
        const secureUrl = secureaccess ? TransmitConstants.endpoints.prod : TransmitConstants.endpoints.securelink;
        const serverUrl = server ? secureUrl : TransmitConstants.endpoints.prodapigee;
        return isInternal ? TransmitConstants.endpoints.prod_proxy : serverUrl;
      }
  }
};
const getServerEndPoint = env => {
  return "https://".concat(env);
};
const configureSDK = (transmitsdk, server, appId, crypto, appEnv, isLoggingEnabled, secureaccess, oAuth2, bearer_token, internal) => {
  let host = appEnv;
  let serverUrl = getServerEndPoint(getEnv(host, server, isLoggingEnabled, secureaccess, internal));
  let applicationId = appId;
  let connectionSettings = {};
  if (!crypto) {
    connectionSettings = window.com.ts.mobile.sdk.SDKConnectionSettings.create(serverUrl, applicationId);
  } else {
    connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.createWithCryptoMode(serverUrl, applicationId, "", "", com.ts.mobile.sdk.ConnectionCryptoMode.Full);
  }
  if (oAuth2) {
    transmitsdk.setTransportProvider(new CustomTransportProvider(bearer_token));
  }
  transmitsdk.setLogLevel(window.com.ts.mobile.sdk.LogLevel.Off);
  transmitsdk.setConnectionSettings(connectionSettings);
  transmitsdk.setEnabledCollectors([window.com.ts.mobile.sdk.CollectorType.DeviceDetails]);
};
const logoutSession = (transmitsdk, isLoggingEnabled) => {
  return new Promise((resolve, reject) => {
    transmitsdk.logout().then(response => {
      //  isPrimarySessionActive = false;
      if (isLoggingEnabled) {
        log.info("onSdkLogoutSuccess", "Primary active session has ended. Previous user logged out.", "transmit");
      }
      resolve(response);
    }).catch(error => {
      if (error.getData) {
        if (error.getErrorCode() !== TransmitConstants.errorCodes.noLoggedInUser) {
          if (isLoggingEnabled) {
            log.error("".concat(error.getErrorCode(), ": ", error.getMessage()), error.getData());
          }
        }
      } else {
        if (isLoggingEnabled) {
          log.error("onSdkLogoutFailure", error);
        }
      }
      reject(error);
    });
  });
};
const initializeSDK = (transmitsdk, isLoggingEnabled) => {
  return new Promise((resolve, reject) => {
    transmitsdk.initialize().then(response => {
      if (isLoggingEnabled) {
        log.info("onSdkInitializeSuccess", transmitsdk, "transmit");
      }
      resolve(response);
    }).catch(error => {
      if (error.getData) {
        if (isLoggingEnabled) {
          log.error("".concat("onSdkInitializeFailure::Error Code: ", error.getErrorCode(), ": ", error.getMessage()), error.getData());
        }
      } else {
        if (isLoggingEnabled) {
          log.error("onSdkInitializeFailure", error);
        }
      }
      reject(error);
    });
  });
};
export { configureSDK, initializeSDK, logoutSession };